import {ArticleStatus} from "@/modules/articles/articles-table/types";

import {ARTICLE_BODY_MIN_CHARS, ARTICLE_URL_PATTERN} from "./types";

export function stripHtmlTags(html: string): string {
  return html.replace(/<[^>]+>/g, '').trim()
}

export function getMissingFieldsForReview(
  title: string | null | undefined,
  summary: string | null | undefined,
  bodyPlainText: string,
): string[] {
  return [
    ...(title?.trim() ? [] : ['title']),
    ...(summary?.trim() ? [] : ['summary']),
    ...(bodyPlainText.length < ARTICLE_BODY_MIN_CHARS ? [`body (min ${ARTICLE_BODY_MIN_CHARS} characters)`] : []),
  ]
}

export function hasUrlInBody(bodyPlainText: string): boolean {
  return ARTICLE_URL_PATTERN.test(bodyPlainText)
}

export function canSubmitForReview(
  status: ArticleStatus,
  missingFieldsCount: number,
  bodyPlainText: string,
): boolean {
  return status === 'DRAFT' && missingFieldsCount === 0 && !hasUrlInBody(bodyPlainText)
}
